import { useNavigate } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'

const MyProjectsDefaultPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { employee: currentEmployee } = useCurrentSession()

  useEffect(() => {
    if (!currentEmployee) return
    navigate(
      navigation.myProjects.employeeId.overview.fullPath({ employeeId: currentEmployee.id }),
      { replace: true }
    )
  }, [currentEmployee?.id])

  return null
}

export default MyProjectsDefaultPage
